export default "__VITE_ASSET__j83l4Y2$__"